<template>
  <div>
    <img class="m-b-15" src="../../../assets/images/modals/ico057.svg" alt="Set Delivery Details">
    <text-string label-id="txt1140" class="m-b-10"/>
    <text-string label-id="txt1141"/>
  </div>
</template>

<script>
  export default {
    name: "modal-view-pharmacy-orders-step-two"
  }
</script>

<style scoped>

</style>